export default {
  methods: {
    /**
     * 手机号脱敏 isSplicing 是否拼接区号
     * */
    telDes (str, MobileCountryCode, isSplicing) {
      if (!str && str !== 0) {
        return ''
      }

      // if (!this.isPhoneNumber(str, MobileCountryCode)) { // 格式错误的不做脱敏
      //   return isSplicing ? this.telSplicingAreaCode(str, MobileCountryCode) : str
      // }

      if (!this.getSetting('常用配置:用户隐私')) {
        return isSplicing ? this.telSplicingAreaCode(str, MobileCountryCode) : str
      }
      str = str + ''
      return isSplicing ? this.telSplicingAreaCode(this.certificatesDes(str), MobileCountryCode) : this.certificatesDes(str)
    },

    telSplicingAreaCode(str, MobileCountryCode) {
      if (str && MobileCountryCode) {
        return `${MobileCountryCode} ${str}`
      }
      return str || ''
    },

    /**
     * 邮箱脱敏
     * */
    emailDes (email) {
      if (!email && email !== 0) {
        return ''
      }

      // if (!this.isEmail(email)) { // 校验邮箱不正确的不做脱敏
      //   return email
      // }

      if (!this.getSetting('常用配置:用户隐私')) {
        return email
      }
      let newEmail = email
      if (String(email).indexOf('@') > 0) {
        let str = email.split('@')
        let name = str[0]
        return `${this.certificatesDes(name)}@${str[1]}`
      }
      return newEmail
    },

    /**
     * 证件号 脱敏
     * */
    certificatesDes (str) {
      if (!str && str !== 0) {
        return ''
      }
      if (!this.getSetting('常用配置:用户隐私')) {
        return str
      }
      str = str + ''
      let len = str.length;
      // if (len >= 8) {
      //   return str.replace(/^(.{3})(?:[\s\S]+)(.{3})$/, `$1${starMap(str, 3, -3)}$2`)
      // }
      if (len > 6) { // 身份证号
        return str.replace(/^(.{3})(?:[\s\S]+)(.{3})$/, `$1${starMap(str, 3, -3)}$2`)
      }
      if (len === 6) { // 身份证号
        return str.replace(/^(.{2})(?:[\s\S]+)(.{2})$/, `$1${starMap(str, 2, -2)}$2`)
      }
      if (len >= 3) {
        return str.replace(/^(.{1})(?:[\s\S]+)(.{1})$/, `$1${starMap(str, 1, -1)}$2`)
      }
      if (len > 1) {
        return str.replace(/^(.{1})(?:[\s\S]+)(.{0})$/, `$1${starMap(str, 1, len)}$2`)
      }
      if (len === 1) {
        return '*'
      }
      function starMap (str, start, end) {
        return str.slice(start, end).replace(/[\s\S]/g, '*')
      }
      return str
    }
  }
}
